import { Checkbox, FormControlLabel } from '@mui/material';
import { useCallback } from 'react';
import { FilterKey } from '@/pages/ValuationsV2/components/Filters/filterConfig';
import type { ValuationsFilters } from '../../store/valuationsStore';
import { useValuationsStore } from '../../store/valuationsStore';

const WatchListSwitch = () => {
  const watchListView = useValuationsStore.use.watchListView();
  const setWatchListView = useValuationsStore.use.setWatchListView();

  const handleToggle = useCallback(
    (checked: boolean) => {
      setWatchListView(checked);
    },
    [setWatchListView],
  );

  return (
    <FormControlLabel
      labelPlacement='end'
      checked={watchListView}
      sx={{ textTransform: 'uppercase' }}
      control={
        <Checkbox
          onChange={({ target }) => {
            handleToggle(target.checked);
          }}
          data-id='watchlist-checkbox-toggle'
        />
      }
      label='Watch List'
      data-id='watchlist-checkbox-control'
    />
  );
};

const MASwitch = ({ filters, setFilters }: FilterSwitchesProps) => {
  const setFilter = (filter: boolean, name: keyof ValuationsFilters) => {
    const newFilters = {
      ...filters,
      [name]: filter,
    };
    setFilters(newFilters);
  };

  return (
    <FormControlLabel
      labelPlacement='end'
      checked={!!filters[FilterKey.Opportunities]}
      sx={{ textTransform: 'uppercase' }}
      control={
        <Checkbox
          onChange={({ target }) => {
            setFilter(target.checked, FilterKey.Opportunities);
          }}
          data-id='filter-checkboxes-toggle'
        />
      }
      label='M&A Opportunities'
      data-id='filter-checkboxes-control'
    />
  );
};

type FilterSwitchesProps = {
  filters: ValuationsFilters;
  setFilters: (filters: ValuationsFilters) => void;
};

const FilterSwitches = ({ filters, setFilters }: FilterSwitchesProps) => {
  return (
    <>
      <WatchListSwitch />
      <MASwitch filters={filters} setFilters={setFilters} />
    </>
  );
};

export { FilterSwitches };
